/**
 * Which deployment a dashboard URL belongs to, read from the host alone so a
 * domain change does not break it. Production is `app.{domain}.{tld}` and
 * returns null; staging and feature branches are `app.{env}.{domain}.{tld}`.
 */
export function environmentName(url: string): string | null {
  let host: string;
  try {
    host = new URL(url.includes("://") ? url : `https://${url}`).hostname;
  } catch {
    return null;
  }
  if (host === "localhost" || host === "127.0.0.1") return "local";
  const labels = host.split(".");
  if (labels.length === 4 && labels[0] === "app") return labels[1];
  return null;
}

export function environmentIcon(url: string): string {
  const name = environmentName(url);
  if (name === "local") return "/images/icon-development.svg";
  if (name) return "/images/icon-staging.svg";
  return "/images/icon.svg";
}
